// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"36d65e20","553":"d36f483d"}[chunkId] + ".chunk.js";
};